type PageSize = {
    text: string;
    value: number;
};

export const tableSizePerPage: PageSize[] = [
    {
        text: '10',
        value: 10,
    },
    {
        text: '20',
        value: 20,
    },
    {
        text: '50',
        value: 50,
    },
];
